const init = (elements = ".custom-scroll", autoInit = true) => {
    $(elements).each(function () {
        if ((window.innerWidth > 992 && $(this).hasClass("scroll-xs-only")) || (autoInit && $(this).hasClass("manual-init"))) {
            return
        }
        $(this).jScrollPane({
            autoReinitialise: true,
        })

    })


}
window.initCustomScroll = init;

const customScroll = () => {
    init();
    $(window).on("resize", function () {
        init();
    })
    $(document).on("mouseover", ".jspScrollable", function () {
        $("html, body").css({
            overflow: "hidden"
        })
    }).on("mouseout", ".jspScrollable", function () {
        $("html, body").css({
            overflow: "initial"
        })
    })
}

module.exports = customScroll;